"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const isZeroDurationCard_1 = require("../../helpers/isZeroDurationCard");
function getProgressMeasureForTimeBasedContent(duration, subType, timeSpent) {
    if (isZeroDurationCard_1.isZeroDurationContent(duration, subType) && timeSpent) {
        return 1;
    }
    const progressMeasure = duration ? Math.min(duration, timeSpent) / duration : 0;
    return progressMeasure;
}
exports.getProgressMeasureForTimeBasedContent = getProgressMeasureForTimeBasedContent;
//# sourceMappingURL=getProgressMeasureForTimeBasedContent.js.map